import ObservationBox from "../../../../../../components/observation-box/observation-box.jsx";

export default function Observations({ title, data }) {
    const observations = data?.attendance?.data ?? {};

    return (
        <>
            <div className="space-y-8 px-5">
                <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                    {title}
                </h2>
                <div className="flex gap-4">
                    <ObservationBox title="Observação do atendente">
                        {observations?.attendance_observation}
                    </ObservationBox>
                    <ObservationBox title="Observação final">
                        {observations?.attendance_finalobservation}
                    </ObservationBox>
                </div>
            </div>
        </>
    )
}